/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IViewerSourceCreator, IViewerSourceFactory } from '.'
 * @import PoolFactory from '../pool/pool-factory'
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování HTML img elementů..
 * Implementuje návrhový vzor Factory pro tvorbu zdrojů.
 * Pro každé zapůjčení je vytvořený nový zdroj.
 * Místo vracení zdroje ho vždy smaže.
 * @implements {IViewerSourceCreator}
 */
export default class DivViewerSourceCreator {
  /**
   * Vytvoří instanci.
   * @param {PoolFactory} poolFactory
   * @param {IViewerSourceFactory} sourceFactory Továrna na zdroje, které se poskytují.
   */
  constructor(poolFactory, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory);
    this.sourceFactory = sourceFactory;
  }

  /** @type {IViewerSourceCreator['delete']} */
  delete(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @type {IViewerSourceCreator['destroy']} */
  destroy() {
    this.pool.destroy();
  }

  /** @type {IViewerSourceCreator['getLent']} */
  getLent() {
    return this.pool.getLent();
  }

  /** @type {IViewerSourceCreator['getMax']} */
  getMax() {
    return this.pool.getMax();
  }

  /** @type {IViewerSourceCreator['isUsingVideoElement']} */
  isUsingVideoElement() {
    return false;
  }

  /** @type {IViewerSourceCreator['lend']} */
  lend(parentEl) {
    return new Promise((resolve) => {
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se dopředu, aby byl rodičovský element dostupný v okamžiku plnění bazénu.
      this.sourceFactory.setParentEl(parentEl);
      const source = this.pool.lend();
      source.setParentEl(parentEl);
      return resolve(source);
    });
  }

  /** @type {IViewerSourceCreator['receive']} */
  receive(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @type {IViewerSourceCreator['replace']} */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}
